import React, { useState, useEffect } from "react";
import { X, Info } from "lucide-react";

/**
 * Top-of-page banner shown when REACT_APP_SHOW_DEMO_BANNER=true.
 * User can dismiss for the session. Reminds testers this is a beta environment
 * with sample / shared data, not a production system.
 */
export function DemoBanner() {
  const enabled = process.env.REACT_APP_SHOW_DEMO_BANNER === "true";
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(sessionStorage.getItem("tt_demo_banner_dismissed") === "1");
  }, []);

  if (!enabled || dismissed) return null;

  return (
    <div className="bg-sky-50 border-b border-sky-200 text-sky-900 px-4 py-2 text-xs flex items-center justify-center gap-3"
         data-testid="demo-banner">
      <Info className="h-3.5 w-3.5 flex-shrink-0" />
      <span>
        <strong>BETA TEST — system testowany operacyjnie.</strong>{" "}
        Dane od dziś mogą być używane do testów pracowniczych.
      </span>
      <button
        onClick={() => {
          sessionStorage.setItem("tt_demo_banner_dismissed", "1");
          setDismissed(true);
        }}
        className="ml-2 p-1 hover:bg-sky-100 rounded"
        title="Ukryj na tę sesję"
        data-testid="demo-banner-close"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
